import Vue from "vue";

enum GoalRowType {
  PREVIOUS = 0,
  CURRENT = 1,
  PERCENTAGE = 2,
  NOTE = 3
}

export default Vue.extend({
  name: 'RepresentativeGoalReport',
  data() {
    return {
      inputParams: {
        year: 0
      }
    }
  },
  filters: {
    repTrackerFilter(value: any, row: any) {
      if ([GoalRowType.PREVIOUS, GoalRowType.CURRENT].some(goalType => goalType === row.type)){
        return (Vue as any).options.filters.currency(value);
      } else if (row.type === GoalRowType.PERCENTAGE) {
        return (Vue as any).options.filters.percentage(value);
      }
      return value;
    }
  },
  created() {
    this.inputParams.year = new Date().getFullYear();
  },
  methods: {
    isNoteRow(row: any) {
      return row.type === GoalRowType.NOTE;
    },
    isCurrentRow(row: any) {
      return GoalRowType.CURRENT === row.type;
    },
    isCurrencyRow(row: any) {
      return [GoalRowType.PREVIOUS, GoalRowType.CURRENT].some(goalType => goalType === row.type);
    },
    isPercentageRow(row: any) {
      return row.type === GoalRowType.PERCENTAGE;
    },
    getStyleForTotalCell(row: any, value: number) {
      return this.getStyleForCell(row, value, true);
    },
    getStyleForCell(row: any, value: number, totalColumn: boolean = false) {
      const goal = this.getGoalForAmount(row, value, totalColumn);
      return {
        'note-column': this.isNoteRow(row),
        'currency-column': this.isCurrencyRow(row),
        'percentage-column': this.isPercentageRow(row),
        'below-goal': value && goal && this.isCurrentRow(row) && value < goal,
        'meet-goal': value && goal && this.isCurrentRow(row) && value >= goal
      }
    },
    getGoalForAmount(row: any, value: any, totalColumn: boolean) {
      if (value && row.goal && totalColumn) {
        return row.goal * 12;
      } else {
        return row.goal;
      }
    },
    clearInputParams() {
      this.inputParams = {
        year : new Date().getFullYear()
      }
    }
  }
}
);



// WEBPACK FOOTER //
// ./src/components/reports/representativegoal/RepresentativeGoalReport.ts